<template>
  <div class="about">
    <Form
      ref="storeForm"
      :model="store"
      :rules="storeRules"
      inline
      :label-width="125"
      class="form-common"
    >
      <Row>
        <FormItem
          label="超市名称"
          prop="superName"
        >
          <Input
            type="text"
            v-model="store.superName"
            placeholder="请输入超市名称"
          >
          </Input>
        </FormItem>
        <FormItem
          label="门店名称"
          prop="menName"
        >
          <Input
            type="text"
            v-model="store.menName"
            placeholder="请输入门店名称"
          >
          </Input>
        </FormItem>
      </Row>
      <FormItem class="btn-groups">
        <Button
          type="primary"
          @click="handleQuery"
        >查询</Button>
        <!--<Button type="default" @click="handleReset('storeForm')">重置</Button>-->
        <Button
          type="default"
          @click="showModal('add')"
        >新增</Button>
      </FormItem>
    </Form>
    <CTable
      :columns="columns"
      :data="queryData"
      :total="total"
      :current="store.page"
      @change="change"
      :showPage="true"
    />
    <Modal
      :title="insertModalTitle"
      width="800"
      v-model="showEditModal"
      :mask-closable="false"
      @on-cancel="handleReset('editForm')"
    >
      <Form
        ref="editForm"
        :model="editData"
        :rules="editRules"
        inline
        :label-width="125"
      >
        <Row>
          <Col span="24">
          <FormItem
            label="超市"
            prop="superCode"
          >
            <Select
              v-model="editData.superCode"
              filterable
              :remote-method="querySup"
              :loading="supserLoading"
            >
              <Option
                v-for="item in supList"
                :value="item.superCode"
                :label="item.superName"
                :key="item.superCode"
              >{{item.superName }}
              </Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem
            label="门店编码"
            prop="menCode"
          >
            <Input
              type="text"
              v-model="editData.menCode"
              placeholder="请输入门店编码"
            >
            </Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem
            label="门店名称"
            prop="menName"
          >
            <Input
              type="text"
              v-model="editData.menName"
              placeholder="请输入门店名称"
            >
            </Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem
            label="详细地址"
            prop="addr"
          >
            <Input
              type="textarea"
              v-model="editData.addr"
              placeholder="请输入详细地址"
            >
            </Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem
            label="备注"
            prop="remark"
          >
            <Input
              type="textarea"
              v-model="editData.remark"
              placeholder="请输入备注"
            >
            </Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col
            span='8'
            offset='10'
            class="btn-groups"
          >
          <Button
            type="primary"
            @click="editSubmit"
          >保存</Button>
          <Button
            type="default"
            @click="cancelEdit"
          >取消</Button>
          </Col>
        </Row>
      </Form>
      <div slot="footer"></div>
    </Modal>
    <Modal
      title="门店明细"
      width="800"
      v-model="showViewModal"
      :mask-closable="false"
    >
      <Form
        inline
        :label-width="125"
        class="form-text"
      >
        <Row>
          <Col span="12">
          <FormItem label="门店编码">
            <p class="form-static">{{viewData.menCode}}</p>
            </Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="门店名称">
            <p class="form-static">{{viewData.menName}}</p>
            </Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem label="经销商编码">
            <p class="form-static">{{viewData.cusCode}}</p>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="经销商名称">
            <p class="form-static">{{viewData.cusName}}</p>
            </Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem label="超市编码">
            <p class="form-static">{{viewData.superCode}}</p>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="超市名称">
            <p class="form-static">{{viewData.superName}}</p>
            </Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem label="详细地址">
            <p class="form-static">{{viewData.addr}}</p>
            </Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="备注">
            <p class="form-static">{{viewData.remark}}</p>
            </Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
          <FormItem label="创建时间">
            <p class="form-static">{{timeFormat(viewData.createTime, 'time')}}</p>
            </Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="创建人">
            <p class="form-static">{{viewData.createName}}</p>
            </Input>
          </FormItem>
          </Col>
        </Row>
        <!-- <Row>
                  <Col span="12">
                    <FormItem label="修改时间">
                      <p class="form-static">{{timeFormat(viewData.updateTime, 'time')}}</p>
                      </Input>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="修改人">
                      <p class="form-static">{{viewData.updateUser}}</p>
                      </Input>
                    </FormItem>
                  </Col>
                </Row> -->
        <Row>
          <Col span="12">
          <FormItem label="备注">
            <p class="form-static">{{viewData.remark}}</p>
            </Input>
          </FormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>

<script>
import CTable from '@/components/CTable'
import BtnEvent from '@/components/BtnEvent'
import {storeRule} from '@/plugin/validateRule'
import {timeFormat} from '@/plugin/tool'

export default {
  name: 'Store',
  mixins: [BtnEvent],
  components: {
    CTable
  },
  computed: {
    insertModalTitle () {
      const {id}=this.editData||{}
      return id? '编辑门店':'新增门店'
    }
  },
  data () {
    return {
      marketList: [],
      skuList: [],
      cusList: [],
      supList: [],//超市筛选列表
      supserLoading: false,
      store: {
        page: 1,
        pageSize: 10
      },
      total: 0,
      storeRules: {},
      showEditModal: false,
      showViewModal: false,
      edit: false,
      classesList: [],
      queryData: [],
      columns: [{
        title: '门店编码',
        key: 'menCode',
        width: 120,
        render: (h,params) => {
          return h('div',[
            h('a',{
              on: {
                click: () => {
                  this.showModal('view',params.row.id)
                },
              }
            },params.row.menCode)
          ])
        }
      },{
        title: '超市名称',
        key: 'superName'
      },{
        title: '门店名称',
        key: 'menName'
      },{
        width: 120,
        title: '创建时间',
        key: 'createTime',
        render: (h,params) => {
          return h('span',timeFormat(params.row.createTime,'time'))
        }
      },{
        width: 120,
        title: '创建人',
        key: 'createName'
      },{
        width: 120,
        title: '操作',
        key: 'action',
        render: (h,params) => {
          return h('div',[
            h('a',{
              on: {
                click: () => {
                  this.showModal('edit',params.row.id)
                }
              }
            },'修改'),
            h('a',{
              on: {
                click: () => {
                  this.showModal('delete',params.row.id)
                }
              },
              style: {
                marginLeft: '5px'
              }
            },'删除')
          ])
        }
      }],
      editData: {},
      editRules: storeRule,
      viewData: {}
    }
  },
  created () {
    this.queryTableData()
    this.getMarketList()
  },
  methods: {
    onSuperSelect ({label,code}) {
    },
    timeFormat: timeFormat,
    handleQuery () { // 查询表单校验
      this.$refs.storeForm.validate((valid) => {
        if(valid) {
          this.store.page=1
          this.queryTableData()
        }
      })
    },
    queryTableData () { // 查询表格
      this.$fetch('SysSuperMen/getList',this.store).then(res => {
        this.queryData=res.data.list
        this.total=res.data.total
      })
    },
    change (index) {
      this.store.page=index
      this.queryTableData()
    },
    getMarketList () { // 获取超市列表，存货列表
      this.$fetch('SysSku/getCodeName').then(res => {
        this.skuList=res.data.list
      })
    },
    /** 超市 查询列表 */
    querySup (value) {
      this.supserLoading=true
      this.$fetch('SuperApply/getSuperByName',{
        superName: value
      }).then(res => {
        this.supList=res.data.list
        this.supserLoading=false
      })

    },
    queryCus (value) { // 经销商
      this.$fetch('SysCus/getCodeName',{
        cusName: value
      }).then(res => {
        this.cusList=res.data.list
      })
    },
    changeCus (data) { // 根据经销商获取超市列表 门店名称
      _.forEach(this.cusList,value => {
        if(value.cusName===data) {
          this.editData.cusCode=value.cusCode
        }
      })
      //   this.$fetch('SuperApply/getSuper',{
      //     cusCode: this.editData.cusCode
      //   }).then(res => {
      //     if(res.data) {
      //       this.marketList=res.data.list
      //     }
      //   })
    },
    showModal (type,id) {
      this.edit=false
      switch(type) {
        case 'add':
          this.showEditModal=true
          this.edit=false
          this.editData={}
          break
        case 'edit':
          this.$fetch('SysSuperMen/getById',{
            id: id
          }).then(res => {
            this.showEditModal=true
            this.edit=true
            this.editData=res.data
            this.querySup(this.editData.superName)
            this.changeCus(res.data.cusCode)
          })
          break
        case 'view':
          this.$fetch('SysSuperMen/getById',{
            id: id
          }).then(res => {
            this.showViewModal=true
            _.forEach(this.classesList,value => {
              if(value.classCode===res.data.classCode) {
                res.data.className=value.className
              }
            })
            this.viewData=res.data
          })
          break
        case 'delete':
          this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认删除？</p>',
            onOk: () => {
              this.$fetch('SysSuperMen/del',{
                id: id
              }).then(res => {
                this.$Message.info('删除成功')
                this.change(1)
              })
            }
          })
          break
      }
    },
    editSubmit () {
      this.$refs.editForm.validate((valid) => {
        if(valid) {
          this.$fetch('SysSuperMen/save',this.editData,'POST').then(res => {
            this.showEditModal=false
            this.change(1)
            this.$Message.success('提交成功')
          })
        }
      })
    },
    cancelEdit () {
      this.showEditModal=false
      this.handleReset('editForm')
    }
  }
}
</script>
<style>
.ivu-select-dropdown-list {
  height: 400px;
  overflow-y: auto;
}
</style>